import {
  startAuthentication,
  startRegistration,
} from '@simplewebauthn/browser';
import { http } from './http';
import { LoginResponse } from '../types';

const BASE = '/v1/instructor-auth';

/** Le navigateur/appareil supporte-t-il les passkeys (FaceID/Touch ID) ? */
export function webauthnSupported(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.PublicKeyCredential !== 'undefined'
  );
}

/** Le moniteur connecté a-t-il déjà enregistré une passkey ? */
export async function getWebauthnStatus(): Promise<boolean> {
  const { data } = await http.get<{ registered: boolean }>(
    `${BASE}/webauthn/status`,
  );
  return data.registered;
}

/** Enregistre une passkey pour le moniteur connecté (FaceID/Touch ID). */
export async function registerPasskey(): Promise<void> {
  const { data: options } = await http.post(
    `${BASE}/webauthn/register/options`,
  );
  const attResp = await startRegistration({ optionsJSON: options });
  await http.post(`${BASE}/webauthn/register/verify`, { response: attResp });
}

/** Connexion biométrique (sans email) → renvoie la session moniteur. */
export async function loginWithPasskey(): Promise<LoginResponse> {
  const { data } = await http.post<{ options: unknown; challengeId: string }>(
    `${BASE}/webauthn/auth/options`,
  );
  const asseResp = await startAuthentication({
    optionsJSON: data.options as Parameters<
      typeof startAuthentication
    >[0]['optionsJSON'],
  });
  const { data: session } = await http.post<LoginResponse>(
    `${BASE}/webauthn/auth/verify`,
    { challengeId: data.challengeId, response: asseResp },
  );
  return session;
}
